import { capitalize } from "lodash";
import { forwardRef } from "react";
import { Checkbox } from "..";
import classes from "./styles.module.scss";

const OffSiteLandServicingKeys = [
  "water",
  "fire",
  "sewage",
  "storm",
  "power",
  "gas",
  "telephone",
  "cable",
  "other",
];
export const OffSiteLandServicing = forwardRef(
  ({ value = {}, onChange }, ref) => {
    const handleOnChange = (e) => {
      const key = e.target.name;
      value[key] = !value[key];
      onChange(value);
    };
    return (
      <div ref={ref}>
        <div className={"label-text"}> Off-Site Land Servicing To Be Built</div>
        <div className={classes["wrapper"]}>
          {OffSiteLandServicingKeys.map((key) => {
            return (
              <Checkbox
                key={key}
                name={key}
                label={capitalize(key)}
                onChange={handleOnChange}
                checked={value[key]}
              />
            );
          })}
        </div>
      </div>
    );
  }
);
